function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M37.3884 27.9432V16.6148C37.3884 16.2336 37.0545 15.9247 36.6426 15.9247H32.8642V15.1887C32.8642 14.8075 32.5304 14.4986 32.1185 14.4986C31.7066 14.4986 31.3727 14.8075 31.3727 15.1887V15.9247H28.3898V15.1887C28.3898 14.8075 28.0559 14.4986 27.644 14.4986C27.2321 14.4986 26.8983 14.8075 26.8983 15.1887V15.9247H23.9153V15.1887C23.9153 14.8075 23.5815 14.4986 23.1696 14.4986C22.7577 14.4986 22.4239 14.8075 22.4239 15.1887V15.9247H19.4409V15.1887C19.4409 14.8075 19.1071 14.4986 18.6952 14.4986C18.2833 14.4986 17.9494 14.8075 17.9494 15.1887V15.9247H14.171C13.7591 15.9247 13.4253 16.2336 13.4253 16.6148V34.6023C13.4253 34.9834 13.7591 35.2923 14.171 35.2923H26.5903C27.7959 36.9555 29.8461 38.0525 32.1682 38.0525C35.8689 38.0525 38.8798 35.2664 38.8798 31.842C38.8798 30.3667 38.3205 29.0099 37.3884 27.9432ZM17.9494 17.3048V17.9949C17.9494 18.376 18.2833 18.6849 18.6952 18.6849C19.1071 18.6849 19.4409 18.376 19.4409 17.9949V17.3048H22.4239V17.9949C22.4239 18.376 22.7577 18.6849 23.1696 18.6849C23.5815 18.6849 23.9153 18.376 23.9153 17.9949V17.3048H26.8983V17.9949C26.8983 18.376 27.2321 18.6849 27.644 18.6849C28.0559 18.6849 28.3898 18.376 28.3898 17.9949V17.3048H31.3727V17.9949C31.3727 18.376 31.7066 18.6849 32.1185 18.6849C32.5304 18.6849 32.8642 18.376 32.8642 17.9949V17.3048H35.8969V20.0651H14.9168V17.3048H17.9494ZM14.9168 33.9122V21.4452H35.8969V26.6806C34.8297 26.0184 33.5468 25.6315 32.1682 25.6315C29.8117 25.6315 27.7353 26.7613 26.5375 28.466C26.4367 28.4189 26.3231 28.3917 26.2023 28.3917H24.7108C24.2989 28.3917 23.9651 28.7007 23.9651 29.0818C23.9651 29.463 24.2989 29.7719 24.7108 29.7719H25.8405C25.6721 30.2114 25.5556 30.6736 25.4983 31.152H24.7108C24.2989 31.152 23.9651 31.4609 23.9651 31.842C23.9651 32.2232 24.2989 32.5321 24.7108 32.5321H25.4983C25.5556 33.0105 25.6719 33.4727 25.8405 33.9122H14.9168ZM32.1682 36.6724C29.2897 36.6724 26.948 34.5056 26.948 31.842C26.948 29.1785 29.2897 27.0116 32.1682 27.0116C35.0467 27.0116 37.3884 29.1785 37.3884 31.842C37.3884 34.5056 35.0467 36.6724 32.1682 36.6724Z",
  fill: "#0DCF5A"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M35.1511 31.1519H32.9138V29.0817C32.9138 28.7006 32.58 28.3917 32.1681 28.3917C31.7562 28.3917 31.4224 28.7006 31.4224 29.0817V31.842C31.4224 32.2231 31.7562 32.532 32.1681 32.532H35.1511C35.563 32.532 35.8968 32.2231 35.8968 31.842C35.8968 31.4608 35.563 31.1519 35.1511 31.1519Z",
  fill: "#0DCF5A"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M20.1869 22.8713H18.6954C18.2835 22.8713 17.9497 23.1802 17.9497 23.5614C17.9497 23.9425 18.2835 24.2514 18.6954 24.2514H20.1869C20.5988 24.2514 20.9327 23.9425 20.9327 23.5614C20.9327 23.1802 20.5988 22.8713 20.1869 22.8713Z",
  fill: "#0DCF5A"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M20.1869 25.6314H18.6954C18.2835 25.6314 17.9497 25.9403 17.9497 26.3215C17.9497 26.7026 18.2835 27.0115 18.6954 27.0115H20.1869C20.5988 27.0115 20.9327 26.7026 20.9327 26.3215C20.9327 25.9403 20.5988 25.6314 20.1869 25.6314Z",
  fill: "#0DCF5A"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M20.1869 28.3917H18.6954C18.2835 28.3917 17.9497 28.7006 17.9497 29.0817C17.9497 29.4629 18.2835 29.7718 18.6954 29.7718H20.1869C20.5988 29.7718 20.9327 29.4629 20.9327 29.0817C20.9327 28.7006 20.5988 28.3917 20.1869 28.3917Z",
  fill: "#0DCF5A"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M24.7108 24.2514H26.2023C26.6142 24.2514 26.948 23.9425 26.948 23.5614C26.948 23.1802 26.6142 22.8713 26.2023 22.8713H24.7108C24.2989 22.8713 23.9651 23.1802 23.9651 23.5614C23.9651 23.9425 24.2989 24.2514 24.7108 24.2514Z",
  fill: "#0DCF5A"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M24.7108 27.0115H26.2023C26.6142 27.0115 26.948 26.7026 26.948 26.3215C26.948 25.9403 26.6142 25.6314 26.2023 25.6314H24.7108C24.2989 25.6314 23.9651 25.9403 23.9651 26.3215C23.9651 26.7026 24.2989 27.0115 24.7108 27.0115Z",
  fill: "#0DCF5A"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M20.1869 31.1519H18.6954C18.2835 31.1519 17.9497 31.4608 17.9497 31.8419C17.9497 32.2231 18.2835 32.532 18.6954 32.532H20.1869C20.5988 32.532 20.9327 32.2231 20.9327 31.8419C20.9327 31.4608 20.5988 31.1519 20.1869 31.1519Z",
  fill: "#0DCF5A"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M30.6766 24.2514H32.1681C32.58 24.2514 32.9139 23.9425 32.9139 23.5614C32.9139 23.1802 32.58 22.8713 32.1681 22.8713H30.6766C30.2647 22.8713 29.9309 23.1802 29.9309 23.5614C29.9309 23.9425 30.2647 24.2514 30.6766 24.2514Z",
  fill: "#0DCF5A"
});

var _ref11 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 25.5,
  cy: 26.7486,
  r: 24,
  stroke: "#000840",
  strokeWidth: 2
});

var _ref12 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 43.5,
  cy: 12.5,
  r: 12.5,
  fill: "#E64B38"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M42.3344 6.4H45.6824L45.1244 14.626H42.8924L42.3344 6.4ZM44.0084 19.144C43.5164 19.144 43.1024 18.988 42.7664 18.676C42.4424 18.352 42.2804 17.962 42.2804 17.506C42.2804 17.05 42.4424 16.672 42.7664 16.372C43.0904 16.06 43.5044 15.904 44.0084 15.904C44.5124 15.904 44.9264 16.06 45.2504 16.372C45.5744 16.672 45.7364 17.05 45.7364 17.506C45.7364 17.962 45.5684 18.352 45.2324 18.676C44.9084 18.988 44.5004 19.144 44.0084 19.144Z",
  fill: "white"
});

var SvgIconUpcomingPlanned = function SvgIconUpcomingPlanned(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 56,
    height: 52,
    viewBox: "0 0 56 52",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconUpcomingPlanned, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-upcoming-planned.2425ad8e.svg";
export { ForwardRef as ReactComponent };